var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"model-manager"},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":5}},[_c('model-provider-list',{on:{"select-provider":_vm.handleProviderSelect}})],1),_c('el-col',{attrs:{"span":19}},[_c('model-list',{attrs:{"provider":_vm.selectedProvider}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }